import React from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "./CollasableWrapper.css";
// import { FaPlus, FaMinus } from "react-icons/fa";

const CollapsableWrapper = (props) => {

  return (
    <>
      <Accordion eventKey="0" >
   
        <Card style={{ overflow: "visible" }} className="mycard">
       
          <Card.Header >
            <Accordion.Toggle as={Button} variant="link" eventKey="0">
              {props.clickText}
            </Accordion.Toggle>

          </Card.Header>
       
          <Accordion.Collapse eventKey="0">
            <Card.Body className="body-collapsable">{props.children}</Card.Body>
          </Accordion.Collapse>
        </Card>
        
      </Accordion>
    </>
  );
};

export default CollapsableWrapper;
